/**
 * Auth discipline constants.
 *
 * Source of truth: DOC1 §7.3 (OTP rules), §9 (session model).
 * These are typed `as const` so every consumer reads the same numbers — no
 * drift between docs and code. Server-side enforced per CLAUDE.md §11.
 */
export const OtpRules = {
    /** 6-digit numeric code. */
    length: 6,
    /** Valid for 10 minutes. */
    ttlSeconds: 600,
    /** Resend permitted only after 30 seconds. */
    resendAfterSeconds: 30,
    /** Blocked after 3 wrong tries. */
    maxAttempts: 3,
    /** Max 5 OTP requests per hour per user. */
    maxRequestsPerHour: 5,
    /** SEC-4: register-mode endpoints (seller signup, lift claim, mobile
     *  registration) SMS any mobile with no prior-account check, so the
     *  per-mobile cap above doesn't stop one source pumping SMS costs across
     *  many mobiles. Max register-mode OTP sends per hour, per source IP. */
    maxRegisterRequestsPerHourPerIp: 10,
    /** Max register-mode OTP sends per hour, globally across all IPs — a
     *  backstop against a distributed/rotating-IP send burst. */
    maxRegisterRequestsPerHourGlobal: 200,
};
export const SessionRules = {
    /** 24-hour JWT access token. */
    jwtTtlSeconds: 86_400,
    /** 30-day refresh token (T021 decision). */
    refreshTtlSeconds: 30 * 86_400,
};
//# sourceMappingURL=rules.js.map